import type { ReactNode } from 'react';

export type CalloutKind = 'note' | 'decision' | 'caution';

const LABEL: Record<CalloutKind, string> = {
  note: 'Note',
  decision: 'Decision',
  caution: 'Caution',
};

// The only custom component content authors may use (CONTENT-SPEC §2):
//   <Callout kind="note|decision|caution">…</Callout>
// All three are 1px-ruled panels on cream-light. "decision" carries the one
// brass element of the composition — a 3px brass rule on the left edge.
const Callout = ({ kind = 'note', children }: { kind?: CalloutKind; children: ReactNode }) => {
  const k: CalloutKind = kind in LABEL ? kind : 'note';
  const edge =
    k === 'decision'
      ? 'border-l-[3px] border-l-brass'
      : k === 'caution'
        ? 'border-l-[3px] border-l-forest'
        : '';
  return (
    <aside
      className={`not-prose my-8 border border-forest/40 bg-cream-light px-6 py-5 ${edge}`}
      role={k === 'caution' ? 'note' : undefined}
    >
      <p className="label mb-2">{LABEL[k]}</p>
      <div className="text-body [&>p]:mb-3 [&>p:last-child]:mb-0 [&_a]:underline [&_a]:underline-offset-[0.18em]">
        {children}
      </div>
    </aside>
  );
};

export default Callout;
